var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeal = function SvgMeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "meal_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#meal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.718 14.847a.6.6 0 0 1-.47-.199.47.47 0 0 1-.114-.448q.333-1.25 1.772-2.065 1.44-.813 3.671-.813 2.211 0 3.65.813 1.44.814 1.773 2.065a.47.47 0 0 1-.114.448.6.6 0 0 1-.47.199zm12.034 5.527v-.834h1.168l1.168-11.368H11.58l-.021-.166q-.021-.313.178-.49a.74.74 0 0 1 .51-.178h3.066v-2.92q0-.166.115-.292a.4.4 0 0 1 .302-.125.4.4 0 0 1 .292.125.4.4 0 0 1 .125.292v2.92h3.108q.314 0 .51.219a.63.63 0 0 1 .158.532l-1.168 11.534q-.063.375-.302.563a.94.94 0 0 1-.595.188zm-2.774-6.361q-.375-.772-1.522-1.315t-2.92-.542-2.91.542-1.533 1.314zM4.446 17.62a.4.4 0 0 1-.302-.125.42.42 0 0 1-.115-.292.4.4 0 0 1 .115-.303.4.4 0 0 1 .302-.114h10.2a.42.42 0 0 1 .292.114.4.4 0 0 1 .125.303.4.4 0 0 1-.125.292.4.4 0 0 1-.292.125zm0 2.753a.4.4 0 0 1-.302-.125.42.42 0 0 1-.115-.292.4.4 0 0 1 .115-.303.4.4 0 0 1 .302-.114h10.2a.4.4 0 0 1 .292.125.4.4 0 0 1 .125.292.4.4 0 0 1-.125.303.42.42 0 0 1-.292.114z"
  }))));
};
export default SvgMeal;